'use client';

import React, { createContext, useContext, useState } from 'react';

// Define allowed mode types
export type ModeType = 'inline' | 'bottom-bar';

// Define context shape
interface ModeContextType {
  mode: ModeType;
  setMode: (mode: ModeType) => void;
}

// Create context with a default undefined value
const ModeContext = createContext<ModeContextType | undefined>(undefined);

export const ModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mode, setMode] = useState<ModeType>('inline');

  return <ModeContext.Provider value={{ mode, setMode }}>{children}</ModeContext.Provider>;
};

// Custom hook for cleaner usage
export const useMode = (): ModeContextType => {
  const context = useContext(ModeContext);

  if (!context) {
    throw new Error('useMode must be used inside ModeProvider');
  }

  return context;
};
